import React, { Fragment, useContext, useCallback, useEffect } from "react";
import clsx from "clsx";
import {
  Grid,
  FormHelperText,
  InputLabel,
  Typography,
  Tooltip,
} from "@material-ui/core";
import { CloudUpload, HelpOutline } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import Dropzone from "react-dropzone";

// Contexts
import CampaignContext from "../../../../context/campaign/CampaignContext";
import LayoutContext from "../../../../context/layout/LayoutContext";

const useStyles = makeStyles((theme) => ({
  inputBox: {
    padding: "0 0.5rem",
  },
  input: {
    height: "0.8rem",
  },
  helper: {
    fontSize: "0.7rem",
    lineHeight: "normal",
  },
  dropzone: {
    height: 150,
    width: "98%",
    margin: "0.5rem auto",
    border: "1px dashed lightgrey",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "darkgrey",
  },
  dropzoneHover: {
    "&:hover": {
      cursor: "pointer",
      color: "grey",
      backgroundColor: "rgba(220, 220, 220, 0.2)",
      borderWidth: 3,
    },
  },
  dropzoneError: {
    borderWidth: 2,
    borderColor: theme.palette.error.main,
  },
  image: {
    objectFit: "contain",
  },
}));

const TabImages = () => {
  const classes = useStyles();

  const { checkout_data, checkout_error, setCheckoutData, setCheckoutError } =
    useContext(CampaignContext);
  const { setAlert } = useContext(LayoutContext);

  const onDrop = useCallback((acceptedFiles, id) => {
    const file = acceptedFiles[0];

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        // Preview Image
        if (id === "logo") {
          checkout_data.images.logo = reader.result;
        } else {
          checkout_data.images.banner[id] = reader.result;
        }

        // Remove Error Message
        if (checkout_error.images) {
          if (
            checkout_data.images.logo &&
            checkout_data.images.banner[0] &&
            checkout_data.images.banner[1] &&
            checkout_data.images.banner[2]
          ) {
            checkout_error.images = "";
          }
        }

        setCheckoutData(checkout_data);
        setCheckoutError(checkout_error);
      };
    }
  }, []);

  const onDropRejected = useCallback(() => {
    setAlert("Image file only.", "error");
  }, []);

  const dropzone = (label, id, url) => {
    return (
      <Dropzone
        accept="image/*"
        multiple={false}
        onDrop={(e) => onDrop(e, id)}
        onDropRejected={() => onDropRejected()}
      >
        {({ getRootProps, getInputProps }) => (
          <Grid item xs={6} className={classes.inputBox}>
            <InputLabel shrink required className={classes.input}>
              {label} &nbsp;
              {id === "logo" && (
                <Tooltip
                  placement="top-start"
                  title={
                    <div className={classes.helper}>
                      Crop the logo image to fit the box if necessary.
                    </div>
                  }
                >
                  <HelpOutline fontSize="medium" color="error" />
                </Tooltip>
              )}
            </InputLabel>
            <Grid
              id={id}
              item
              container
              className={clsx({
                [classes.dropzone]: true,
                [classes.dropzoneHover]: true,
                [classes.dropzoneError]: checkout_error.images && !url,
              })}
              {...getRootProps()}
            >
              <input id={id} {...getInputProps()} />
              {url ? (
                <img
                  height="110"
                  width="100%"
                  src={url}
                  className={classes.image}
                  alt=""
                />
              ) : (
                <span>
                  <CloudUpload />
                  <Typography variant="body2">
                    Drag and drop file here or click to select file
                  </Typography>
                </span>
              )}
            </Grid>
          </Grid>
        )}
      </Dropzone>
    );
  };

  return (
    <Fragment>
      <Grid item xs={12}>
        <FormHelperText margin="dense">
          * Drag and drop or click on image to <strong> replace </strong>
          preview image(s). <br />
          <strong
            style={{ color: "red" }}
          >
            {checkout_error.images}
          </strong>
        </FormHelperText>
      </Grid>
      {dropzone("Logo", "logo", checkout_data.images.logo)}
      {dropzone("Top Banner", "0", checkout_data.images.banner[0])}
      {dropzone(
        "Left Banner (Under Bundle Items)",
        "1",
        checkout_data.images.banner[1]
      )}
      {dropzone(
        "Right Banner (Under Checkout Summary)",
        "2",
        checkout_data.images.banner[2]
      )}
    </Fragment>
  );
};

export default TabImages;
